import * as React from "react";
import { cn } from "@gerama/utils";
import {
  stateDescriptionVariants,
  stateIconBadgeVariants,
  stateRootVariants,
  stateTitleVariants,
  type StateVariant,
} from "./error-state";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  variant?: StateVariant;
  className?: string;
}

/** The `empty` state of the loading -> error -> empty -> content machine (skill 9.1). */
export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = "panel",
  className,
}: EmptyStateProps) {
  const immersive = variant === "immersive";
  return (
    <div className={cn(stateRootVariants({ variant }), !immersive && "border-dashed", className)}>
      {icon && (
        <div
          className={cn(
            stateIconBadgeVariants({ variant }),
            immersive ? "bg-primary/15 text-primary" : "text-muted-foreground",
          )}
        >
          {icon}
        </div>
      )}
      <div className={immersive ? "space-y-2" : "space-y-1"}>
        <p className={stateTitleVariants({ variant })}>{title}</p>
        {description && <p className={stateDescriptionVariants({ variant })}>{description}</p>}
      </div>
      {action}
    </div>
  );
}
